import { render, staticRenderFns } from "./ItemTransportAsTransport.vue?vue&type=template&id=d0ae4252&scoped=true"
import script from "./ItemTransportAsTransport.vue?vue&type=script&lang=js"
export * from "./ItemTransportAsTransport.vue?vue&type=script&lang=js"
import style0 from "./ItemTransportAsTransport.vue?vue&type=style&index=0&id=d0ae4252&prod&scoped=true&lang=css"
import style1 from "./ItemTransportAsTransport.vue?vue&type=style&index=1&id=d0ae4252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ae4252",
  null
  
)

export default component.exports